"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Switch = _interopRequireDefault(require("@mui/material/Switch/Switch.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _FormControlLabel = _interopRequireDefault(require("../FormControlLabel"));

var _excluded = ["width", "margin", "hint"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyle = (0, _makeStyles.default)({
  root: {
    padding: 0,
    width: 50,
    height: 30
  },
  switchBase: {
    padding: 1,
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      color: _Colors.default.white,
      '& + .MuiSwitch-track': {
        backgroundColor: _Colors.default.orange,
        opacity: 1
      }
    },
    '&.Mui-disabled': {
      color: _Colors.default.white
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: function backgroundColor(_ref) {
        var checked = _ref.checked;
        return checked ? "".concat(_Colors.default.orange, "80") : _Colors.default.white;
      },
      border: function border(_ref2) {
        var checked = _ref2.checked;
        return "1.5px solid ".concat(checked ? "".concat(_Colors.default.orange, "20") : _Colors.default.lightGrey);
      }
    }
  },
  thumb: {
    width: 28,
    height: 28
  },
  track: {
    'box-sizing': 'border-box',
    borderRadius: 31 / 2,
    backgroundColor: _Colors.default.white,
    opacity: 1,
    height: 30,
    border: function border(_ref3) {
      var checked = _ref3.checked;
      return "1.5px solid ".concat(checked ? '#db5f14' : _Colors.default.lightGrey);
    }
  },
  hintStyle: function hintStyle(_ref4) {
    var width = _ref4.width,
        disabled = _ref4.disabled;
    return {
      width: width,
      height: '16px',
      lineHeight: '16px',
      fontFamily: 'Lato',
      display: 'block',
      fontSize: '11px',
      color: _Colors.default.secondaryGrey,
      opacity: disabled ? 0.6 : 1,
      paddingLeft: '13px',
      position: 'absolute',
      bottom: '-16px',
      overflow: 'hidden',
      boxSizing: 'border-box'
    };
  },
  checked: {},
  switchWrapper: function switchWrapper(_ref5) {
    var margin = _ref5.margin,
        width = _ref5.width;
    return {
      margin: margin,
      width: width,
      position: 'relative'
    };
  }
});

var Switch = /*#__PURE__*/_react.default.forwardRef(function (_ref6, ref) {
  var width = _ref6.width,
      margin = _ref6.margin,
      hint = _ref6.hint,
      rest = _objectWithoutProperties(_ref6, _excluded);

  var disabled = rest.disabled,
      readOnly = rest.readOnly,
      checked = rest.checked;
  var disabledOrReadonly = disabled || readOnly;
  var classes = useStyle({
    checked: checked,
    width: width,
    margin: margin,
    disabled: disabledOrReadonly
  });
  var switchWrapper = classes.switchWrapper,
      hintStyle = classes.hintStyle,
      root = classes.root,
      switchBase = classes.switchBase,
      thumb = classes.thumb,
      track = classes.track,
      checkedClass = classes.checked,
      disabledClass = classes.disabled;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: switchWrapper
  }, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, _extends({
    ref: ref,
    width: "100%",
    control: /*#__PURE__*/_react.default.createElement(_Switch.default, {
      color: "default",
      classes: {
        root: root,
        switchBase: switchBase,
        thumb: thumb,
        track: track,
        checked: checkedClass,
        disabled: disabledClass
      },
      disableRipple: true,
      inputProps: {
        readOnly: readOnly
      }
    })
  }, rest)), /*#__PURE__*/_react.default.createElement("span", {
    className: hintStyle
  }, hint));
});

var _default = Switch;
exports.default = _default;